import {  
    getFirestore, 
    doc,
    deleteDoc
} from "firebase/firestore";
const removeOrg = async function(id) {

    let db = getFirestore();
    const docRef = doc(db, "wellness_org", id);
    await deleteDoc(docRef)
};

export default removeOrg;
